import { IGetEvaluationsResponse } from "types/allnetServices";
import { ITypedAPITarget } from "./NetworkStapler";

export function getEvaluations(): ITypedAPITarget<IGetEvaluationsResponse> {
    return {
        url: "/allnetservices/evaluations",
        headers: {
            "Accept": "application/json",
        },
        parse: (json: any) => {
            return json as IGetEvaluationsResponse;
        },
    };
}


// WEBPACK FOOTER //
// ./src/network/AllnetAPI.ts